<template>
  <v-container class="page">
    <v-card v-show="!overlay">
      <v-toolbar
        color="cyan"
        dark
        flat
      >
        <v-toolbar-title>Asset Manager</v-toolbar-title>
        <v-spacer />
        <v-btn
          color="white"
          :loading="loadingUpdate"
          :disabled="loadingUpdate"
          @click="generateReport"
          outlined
        >
          Generate Report
        </v-btn>
        <template #extension>
          <v-tabs
            v-model="selectedType"
            centered
          >
            <v-tab
              v-for="assetType in assetTypesSorted"
              :key="assetType.id"
            >
              {{ assetType.name }}
            </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>
      <v-tabs-items v-model="selectedType">
        <v-tab-item
          v-for="assetType in assetTypesSorted"
          :key="assetType.id"
        >
          <VehicleManagement
            v-if="parseInt(assetType.is_vehicle) === 1"
            :asset-type="parseInt(assetType.id)"
          />
          <AssetManagement
            v-else
            :asset-type="parseInt(assetType.id)"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <v-alert
      outlined
      type="warning"
      prominent
      border="left"
      v-show="!assetTypes.length && !overlay"
    >
      There is no data available for Asset Type. You can create on <b><router-link to="/asset_type">Asset Type Page</router-link></b>
    </v-alert>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
  </v-container>
</template>
<script>
import VehicleManagement from "@/views/VehicleManagement";
import AssetManagement from "@/views/AssetManagement";
import sortBy from "lodash/sortBy";

export default {
    components: {
        VehicleManagement,
        AssetManagement
    },
    data: () => ({
        selectedType: null,
        assetTypes: [],
				overlay: false,
				responseReport: [],
				loadingUpdate: false,
				loader: null,
				
    }),
    created() {
        this.getAssetTypes();
    },
    computed: {
        assetTypesSorted() {
            return sortBy(this.assetTypes, 'id');
        },
        clientid() {
            return this.$store.state.clientid;
        },
    },
    methods: {
				generateReport() {
					this.loadingUpdate = true;
					this.loader = this.loadingUpdate;
					this.$store.dispatch('API_CALL', {
						$method: 'get_report',
						$postData: {
							clientid: this.clientid,
							report_type: "assets"
						},
					})
					.then((response) => {
						this.loadingUpdate = false;
						this.loader = this.loadingUpdate;
						if(response.data.code == 200){
							this.responseReport = response.data.data.report;
							var fileURL = this.responseReport;
							var fileLink = document.createElement('a');
							fileLink.href = fileURL;
							document.body.appendChild(fileLink);
							fileLink.click();
						}
					});
				},
        getAssetTypes() {
            this.overlay = true;
            this.$store.dispatch('API_CALL', {
							$method: 'get_asset_types',
							$postData: {
                clientid: this.clientid
							},
            })
						.then((response) => {
								this.assetTypes = response.data.data;
								this.overlay = false
						})
        }
    }
}
</script>
